import { useMutation } from "@apollo/client/react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import type { RegisterMutation } from "@/codegen/graphql/generated/graphql";
import { REGISTER } from "@/codegen/graphql/mutations/Register.mutation";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

const useUserRegister = () => {
  const [register] = useMutation<RegisterMutation>(REGISTER);

  const getFingerprint = async () => {
    const fp = await fpPromise;
    const result = await fp.get();
    return result.visitorId + "." + new Date().getTime();
  };

  const registerUser = async (uid: string) => {
    const { data } = await register({
      variables: {
        input: { uid },
      },
    });
    return data?.register;
  };

  return { registerUser, getFingerprint };
};

export default useUserRegister;
